import script from "./digitizerMonitor.vue?vue&type=script&lang=ts&setup=true"
export * from "./digitizerMonitor.vue?vue&type=script&lang=ts&setup=true"

import "./digitizerMonitor.vue?vue&type=style&index=0&id=34d6f921&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d6f921"]])

export default __exports__